import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, BookOpen, Star } from 'lucide-react';
import { CTAButton } from './Shared';
export const Hero = () => {
  return <div className="relative overflow-hidden pt-12 pb-8 md:pt-20 md:pb-12" data-id="element-115">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-surfaceLight/60 rounded-full blur-[140px] -z-10 pointer-events-none" data-id="element-116"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-x-[8px] space-y-[0px]" data-id="element-118">
          <div className="inline-flex items-center bg-brand-surface border border-brand-gold/30 px-4 py-1.5 rounded-full mb-4 space-x-2" data-id="element-119">
            <span className="text-xl" data-id="element-120">🌟</span>
            <span className="font-serif font-semibold tracking-wider text-brand-gold text-sm md:text-base" data-id="element-121">
              LUMEN AKASHA™
            </span>
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-serif font-bold mb-8 text-[20px]" data-id="element-122">
            Todo tu proceso de sanación.
            <br data-id="element-123" />
            <span className="gold-gradient-text text-[24px]" data-id="element-124">
              Listo. Desde hoy.
            </span>
          </h1>

          <div className="mb-8 relative z-10" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/sR2os1FGyTigXLp3XZEd7r/mockups_1.png" alt="Lumen Akasha Mega Pack" className="w-full max-w-3xl mx-auto drop-shadow-[0_20px_50px_rgba(212,175,55,0.25)]" data-id="element-126" />
          </div>

          <div className="max-w-3xl mx-auto mb-8 space-y-3 px-4" data-id="element-127">
            <p className="md:text-xl font-bold text-brand-gold text-[14px]" data-id="element-128">
              El sistema N°1 de sanación emocional akáshica para mujeres que
              quieren soltar lo viejo y avanzar hacia su próxima etapa
            </p>
            <p className="md:text-base text-brand-text/80 text-[12px]" data-id="element-129">
              Sin años de terapia. Sin perderse en el proceso.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-12 text-xs md:text-sm font-medium" data-id="element-130">
            <div className="flex items-center bg-brand-surfaceLight/50 px-4 py-2 rounded-full border border-white/10 whitespace-nowrap text-[10px]" data-id="element-131">
              <FileText className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-132" />
              100% PDF
            </div>
            <div className="flex bg-brand-surfaceLight/50 px-4 py-2 rounded-full border border-white/10 whitespace-nowrap pl-[1px] pr-[1px] flex-row items-start justify-center" data-id="element-133">
              <Zap className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-134" />
              Acceso en 5 min
            </div>
            <div className="flex items-center bg-brand-surfaceLight/50 px-4 py-2 rounded-full border border-white/10 whitespace-nowrap text-[10px]" data-id="element-135">
              <BookOpen className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-136" />6
              Tomos completos
            </div>
          </div>

          <div className="flex flex-col items-center space-y-6" data-id="element-137">
            <CTAButton className="text-xl px-10 py-5" data-id="element-138">
              👉 QUIERO MI MÉTODO AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-muted" data-id="element-139">
              <div className="flex items-center text-[10px]" data-id="element-140">
                <Shield className="w-4 h-4 mr-1.5" data-id="element-141" /> Garantía 7 días
              </div>
              <div className="flex items-center text-[10px]" data-id="element-142">
                <Lock className="w-4 h-4 mr-1.5" data-id="element-143" /> Pago seguro
              </div>
              <div className="flex items-center text-[10px]" data-id="element-144">
                <CreditCard className="w-4 h-4 mr-1.5" data-id="element-145" /> Mercado Pago
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Social Proof Bar */}
      <div className="mt-12 border-y border-brand-gold/10 bg-brand-surface/50 py-4 pt-[1px] pb-[1px]" data-id="element-146">
        {/* Mobile: wrapped grid */}
        <div className="md:hidden flex flex-wrap justify-center gap-x-6 gap-y-2 px-4 text-[13px]" data-id="element-147">
          <div className="flex items-center" data-id="element-148">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-149">+300</span>
            personas ya sanando
          </div>
          <div className="flex items-center" data-id="element-150">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-151">6</span> Tomos
            listos
          </div>
          <div className="flex items-center" data-id="element-152">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-153">2</span> Bonus
            incluidos
          </div>
          <div className="flex items-center" data-id="element-154">
            <Star className="w-3.5 h-3.5 text-brand-gold fill-brand-gold mr-1" data-id="element-155" />
            4.9/5 calificación
          </div>
          <div className="flex items-center" data-id="element-156">100% PDF descargable</div>
          <div className="flex items-center" data-id="element-157">
            <Zap className="w-3.5 h-3.5 text-brand-gold mr-1" data-id="element-158" /> Acceso
            inmediato
          </div>
        </div>

        {/* Desktop: horizontal row with dots */}
        <div className="hidden md:flex flex-row items-center space-x-6 justify-center whitespace-nowrap px-4" data-id="element-159">
          <div className="flex items-center text-[15px]" data-id="element-160">
            <span className="font-bold text-brand-gold mr-2" data-id="element-161">+300</span>
            personas ya sanando
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-162"></div>
          <div className="flex items-center text-[15px]" data-id="element-163">
            <span className="font-bold text-brand-gold mr-2" data-id="element-164">6</span> Tomos
            listos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-165"></div>
          <div className="flex items-center text-[15px]" data-id="element-166">
            <span className="font-bold text-brand-gold mr-2" data-id="element-167">2</span> Bonus
            incluidos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-168"></div>
          <div className="flex items-center text-[15px]" data-id="element-169">
            <Star className="w-4 h-4 text-brand-gold fill-brand-gold mr-1" data-id="element-170" />
            4.9/5 calificación
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-171"></div>
          <div className="flex items-center text-[15px]" data-id="element-172">
            100% PDF descargable
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-173"></div>
          <div className="flex items-center text-[15px]" data-id="element-174">
            <Zap className="w-4 h-4 text-brand-gold mr-1" data-id="element-175" /> Acceso inmediato
          </div>
        </div>
      </div>
    </div>;
};